/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["filter-drawer.controls-drawer .filter-list{justify-content:flex-start}filter-drawer .button-with-image{position:relative}filter-drawer .button-with-image:first-of-type{margin-left:0}filter-drawer .button-with-image img{border-radius:4px;width:65px;height:65px}filter-drawer .button-with-image .bottom-label{margin-top:3px;font-size:11px}"];
export { styles as styles };
